export default __webpack_public_path__ + "static/media/sticker-a.a0bc1cfa.png";